import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import he from 'he';

import siteData from '../services/siteData';
import api, { urlParamCharacter } from '../services/api';
import CategoriesLayout from '../layouts/CategoriesLayout';
import Item from '../components/Item';
import FetcherButton from '../components/FetcherButton';

const NUM_CLIENTS = 30;

export default class ClientsPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      clients: Array.from(Array(NUM_CLIENTS).keys()),
      previousPage: 0,
      totalPages: 1,
      title: '',
      isLoading: true,
    };
    this.getClients = this.getClients.bind(this);
    this.getTitle = this.getTitle.bind(this);
  }

  componentDidMount() {
    this.getClients();
  }

  componentDidUpdate(prevProps) {
    const { match } = this.props;
    if (prevProps.match.params.slug !== match.params.slug) {
      this.getClients();
    }
  }

  getClients(page = 1) {
    const { match, history } = this.props;
    const { previousPage } = this.state;

    if (page === 1) {
      this.setState({ clients: Array.from(Array(NUM_CLIENTS).keys()) });
    }

    this.setState({ isLoading: true });

    api.get(`/clients${urlParamCharacter}category=${match.params.slug}&orderby=menu_order&order=asc`)
      .then((response) => {
        if (page > 1) {
          this.setState((prevState) => ({
            clients: [...prevState.clients, ...response.data],
          }));
        } else {
          this.setState({ clients: response.data });
        }

        this.setState({
          previousPage: previousPage + 1,
          totalPages: parseInt(response.headers['x-wp-totalpages'], 10),
          isLoading: false,
        });
      })
      .catch((error) => {
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.error(error);
        }

        history.push('/not-found');
      });

    this.getTitle();
  }

  getTitle() {
    const { match } = this.props;

    api.get(`clients_categories${urlParamCharacter}slug=${match.params.slug}`)
      .then((response) => {
        this.setState({
          title: response.data[0].title.rendered,
        });
      })
      .catch((error) => {
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      });
  }

  render() {
    const { match } = this.props;
    const {
      clients,
      previousPage,
      totalPages,
      title,
      isLoading,
    } = this.state;

    return (
      <CategoriesLayout path="/clients">
        <Helmet>
          <title>{`${title ? `${he.decode(title)} - ` : ''}${siteData.title}`}</title>
        </Helmet>
        <div className="container">
          <h1 className="sr-only">{title}</h1>
          <div className="columns">
            {clients.map((client, i) => (
              <Item
                key={client.slug || i}
                title={client.title && client.title.rendered}
                slug={`${match.params.slug}/${client.slug || ''}`}
                location={client.acf && client.acf.location}
                isLoading={isLoading}
              />
            ))}
          </div>
          <FetcherButton
            isLoading={isLoading}
            previousPage={previousPage}
            totalPages={totalPages}
            getItems={this.getClients}
          />
        </div>
      </CategoriesLayout>
    );
  }
}

ClientsPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      slug: PropTypes.string,
    }),
  }),
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

ClientsPage.defaultProps = {
  match: { params: { slug: '' } },
};
